import { createFileRoute, Link } from "@tanstack/react-router";
import { HomeNav } from "@/components/home-nav";
import { GuestFilmPlayer } from "@/components/guest-film-player";
import { getSharedFilm } from "@/lib/guest.functions";

export const Route = createFileRoute("/guest-session/film/$id")({
  validateSearch: (s: Record<string, unknown>) => ({ t: typeof s["t"] === "string" ? s["t"] : "" }),
  loaderDeps: ({ search }) => ({ t: search.t }),
  loader: ({ params, deps }) => getSharedFilm({ data: { id: params.id, t: deps.t } }),
  head: () => ({
    meta: [
      { title: "Private Film | Luiza Jesus do Prado" },
      { name: "description", content: "Private screening shared by Luiza Jesus do Prado." },
      { property: "og:title", content: "Private Film — Luiza Jesus do Prado" },
      { property: "og:description", content: "Private screening shared by Luiza Jesus do Prado." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: SharedFilm,
});

function SharedFilm() {
  const { film } = Route.useLoaderData();
  return (
    <>
      <HomeNav />
      <main id="main-content" className="min-h-svh bg-ink px-6 pb-32 pt-28 text-bone md:px-12">
        <div className="mx-auto max-w-[1200px]">
          {film ? (
            <>
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bone/65">
                Private screening · {film.project}
              </p>
              <h1 className="mt-6 font-display text-[clamp(2.5rem,7vw,5.5rem)] font-light leading-[0.95] tracking-tight">
                {film.title}
              </h1>
              <div className="mt-12">
                <GuestFilmPlayer film={film} />
              </div>
              <p className="mt-6 text-sm text-bone/65">Shared privately. Please do not redistribute this link.</p>
            </>
          ) : (
            <>
              <h1 className="font-display text-5xl font-light">Link not valid</h1>
              <p className="mt-6 text-sm text-bone/65">This film link is invalid or has expired.</p>
              <Link to="/guest-session/login" className="mt-8 inline-block min-h-11 border border-bone/60 px-5 py-3 font-mono text-[10px] uppercase tracking-[0.25em]">
                Guest Session
              </Link>
            </>
          )}
        </div>
      </main>
    </>
  );
}
